(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("contextDetect", [], factory);
	else if(typeof exports === 'object')
		exports["contextDetect"] = factory();
	else
		root["contextDetect"] = factory();
})(this, () => {
return 